import { Button } from '../../components';
import React from 'react';
import { LiveStreamingManagement } from '../../services';
import warning from '../../assets/svg/warning.svg';
import '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchLiveStreaming: any;
}

const LiveStreamDelete: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    fetchLiveStreaming,
  } = props;

  const [deleted, setDeleted] = React.useState(false);
  const deleteService = () => {
    LiveStreamingManagement.deleteApi(id).then(() => {
      setDeleted(true);
    });
  };

  return (
    <>
      {!deleted ? (
        <>
          <img src={warning} alt="warning" />
          <h2>
            Delete Event
          </h2>
          <p>
            Are you sure you want to delete this event?
          </p>
          <div className="modalButtonWrapper">
            <Button onClick={handleModalClose}>No</Button>
            <Button intent="danger" onClick={deleteService}>Yes</Button>
          </div>
        </>
      ) : (
        <>
          <h3>
            Event deleted successfully !
          </h3>
          <Button onClick={() => {
            handleModalClose();
            fetchLiveStreaming();
          }}
          >
            Ok
          </Button>
        </>
      )}

    </>
  );
};

export default LiveStreamDelete;
